import {useEffect, useRef} from 'react';


type UsePreviousValueOverload = {
    <T>(value: T, provideInitialValue?: true): T;
    <T>(value: T, provideInitialValue?: false): T | undefined;
};

// src https://stackoverflow.com/a/53446665/5421745
const usePreviousValue: UsePreviousValueOverload = (value, provideInitialValue = false) => {
    const ref = useRef(provideInitialValue ? value : undefined);
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
};

export default usePreviousValue;
